export enum GrantStatusEnum {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
}
